<template>
	<div class="list-group border-radius-2 no-border">
		<WidgetHeader link="/clinical">{{ $t('clinical') }}</WidgetHeader>

		<ClinicalItem
		v-for="(item, i) in clinicalItems"
		:clinicalItem="item"
		:key="i"
		/>

		<template v-if="loading">

			<div class="list-group-item" v-for="i in 3" :key="i">

				<div class="avatar float-left mr-4 mb-3 lg:mb-0 skeleton"></div>
				<div class="float-left">
					<div class="skeleton midnight h20 w200 mb-3"></div>
					<div>
						<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
						<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
						<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
						<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
					</div>
				</div>
			</div>

		</template>

	</div>
</template>

<script>
import WidgetHeader from "./WidgetHeader";
import ClinicalItem from "../ClinicalItem";

export default {
	props: ['limit'],
	components: {
		WidgetHeader,
		ClinicalItem,
	},
	data() {
		return {
			clinicalItems: [],
			loading: true
		}
	},
	methods: {
		getClinicalItems(limit) {
			const dataUrl = `${this.$settings.APIBaseURL}/treatmentsessions/list`;
			const data = {
				limit
			}
			if(this.$UserSession.hasPriv.call(this, 'MARK_TREATMENTSESSIONS')) {
				data.isLocked = 'false';
				data.teacherId = this.$UserSession.getValue("id");
			}
			this.$cfetch(dataUrl, {
				data
			}).then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.loading = false;
					this.clinicalItems = json.treatmentsessions;
				}
			})
		}
	},
	mounted() {
		this.getClinicalItems(this.limit);
	}
};
</script>
